/**
 * @file Album folder related constants.
 */

// minimum gallery (not album) subscription price
const MIN_GALLERY_PRICE = 4000; // $40.00
const MIN_PF_PPG_GALLERY_PRICE = 1999; // $19.99
const MIN_PHOTO_BUNDLE_PRICE = 1000; // $10.00
const MIN_SINGLE_PHOTO_BUNDLE_PRICE = 500; // $5.00

/**
 * @enum ALBUM_FOLDER_JOIN_TYPE
 * @type {{ALL: string, INDIVIDUAL: string}}
 */
const ALBUM_FOLDER_JOIN_TYPE = {
  ALL: 'ALL',
  INDIVIDUAL: 'INDIVIDUAL',
};

/**
 * @enum ALBUM_FOLDER_MEMBERS_SORT
 * @type {{MATCHED_PHOTOS_COUNT: string, LAST_DELIVERED_MATCHED_PHOTO: string, MATCHED_PHOTO_NOTIFICATIONS_COUNT: string}}
 */
const ALBUM_FOLDER_MEMBERS_SORT = {
  MATCHED_PHOTOS_COUNT: 'MATCHED_PHOTOS_COUNT',
  LAST_DELIVERED_MATCHED_PHOTO: 'LAST_DELIVERED_MATCHED_PHOTO',
  MATCHED_PHOTO_NOTIFICATIONS_COUNT: 'MATCHED_PHOTO_NOTIFICATIONS_COUNT',
  IDENTITY_NAME: 'IDENTITY_NAME',
  IDENTITY_LAST_NAME: 'IDENTITY_LAST_NAME',
  IDENTITY_JOINED_DATE: 'IDENTITY_JOINED_DATE',
};

/**
 * @enum ALBUM_FOLDER_MEMBERS_SORT_LABELS
 * @type {{MATCHED_PHOTOS_COUNT: string, LAST_DELIVERED_MATCHED_PHOTO: string, MATCHED_PHOTO_NOTIFICATIONS_COUNT: string}}
 */
const ALBUM_FOLDER_MEMBERS_SORT_LABELS = {
  MATCHED_PHOTOS_COUNT: 'Matched Photos',
  LAST_DELIVERED_MATCHED_PHOTO: 'Last Photo Delivery',
  MATCHED_PHOTO_NOTIFICATIONS_COUNT: 'Total Alerts',
  IDENTITY_NAME: 'First Name',
  IDENTITY_LAST_NAME: 'Last Name',
  IDENTITY_JOINED_DATE: 'Most Recent',
};

const ALBUM_FOLDER_DIGITAL_DOWNLOADS_PRICING_TYPE = {
  PRINT_PACKAGE: 'PRINT_PACKAGE',
  STANDALONE: 'STANDALONE',
};

const PHOTO_SHARING_MODE = {
  WEB_GALLERY_AND_PHOTO_FINDER: 'WEB_GALLERY_AND_PHOTO_FINDER',
  PHOTO_FINDER: 'PHOTO_FINDER',
  WEB_GALLERY: 'WEB_GALLERY',
  INTERNAL: 'INTERNAL',
};

const PHOTO_SHARING_MODE_LABEL = {
  WEB_GALLERY_AND_PHOTO_FINDER: 'Web Gallery + Photo Finder',
  PHOTO_FINDER: 'Photo Finder Only',
  WEB_GALLERY: 'Web Gallery Only',
  INTERNAL: 'Internal Use Only',
};

const PICTURE_DAY_FLOW_STEPS = {
  DETAILS: 'DETAILS',
  ALBUM_FOLDER_LINK: 'ALBUM_FOLDER_LINK',
  PRICING_CATEGORIES: 'PRICING_CATEGORIES',
  SHOOT_TYPE: 'SHOOT_TYPE',
  SHOOT_TYPE_HIERARCHY: 'SHOOT_TYPE_HIERARCHY',
  GREEN_SCREEN: 'GREEN_SCREEN',
  UPLOAD_TYPE: 'UPLOAD_TYPE',
  UNIFORM_TAG_SELECTION: 'UNIFORM_TAG_SELECTION',
  ALBUM_FOLDER_TAGS_LEVEL_CONFIG: 'ALBUM_FOLDER_TAGS_LEVEL_CONFIG',
  GRADE_TAG_INCLUSION: 'GRADE_TAG_INCLUSION',
  GRADE_TAG_SELECTION: 'GRADE_TAG_SELECTION',
  PREFERENCES: 'PREFERENCES',
  YEARBOOK_GRADE_SELECTION: 'YEARBOOK_GRADE_SELECTION',
  YEARBOOK_THUMBNAILS: 'YEARBOOK_THUMBNAILS',
  JOIN_CODE: 'JOIN_CODE',
  DISCOVERY: 'DISCOVERY',
  SUBSCRIPTION_PRICE: 'SUBSCRIPTION_PRICE',
  PRINT_PACKAGES: 'PRINT_PACKAGES',
  PHOTO_PRICING: 'PHOTO_PRICING',
  PRINT_BACKGROUNDS: 'PRINT_BACKGROUNDS',
  CUSTOM_PRINTS: 'CUSTOM_PRINTS',
  SHIPPING: 'SHIPPING',
  MULTI_POSE_SETTINGS: 'MULTI_POSE_SETTINGS',
  BIB_NUMBER_UNIQUENESS: 'BIB_NUMBER_UNIQUENESS',
  REVIEW: 'REVIEW',
};

const ALL_PHOTOS_MODE = {
  NONE: 'NONE',
  JOINED: 'JOINED',
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC',
};

const EVENT_SETTING_RELATIONSHIP = {
  AUNT: 'AUNT',
  BOYFRIEND: 'BOYFRIEND',
  BROTHER: 'BROTHER',
  COWORKER: 'COWORKER',
  DAD: 'DAD',
  DAUGHTER: 'DAUGHTER',
  FRIEND: 'FRIEND',
  GIRLFRIEND: 'GIRLFRIEND',
  GRANDFATHER: 'GRANDFATHER',
  GRANDMOTHER: 'GRANDMOTHER',
  HUSBAND: 'HUSBAND',
  ME: 'ME',
  MOM: 'MOM',
  SISTER: 'SISTER',
  SON: 'SON',
  UNCLE: 'UNCLE',
  WIFE: 'WIFE',
  OTHER: 'OTHER',
};

const EVENT_SETTING_ANNIVERSARY = {
  WEDDING: 'WEDDING',
  WORK: 'WORK',
};

const ALBUM_FOLDER_EXPIRATON_STATUS = {
  EXPIRED: 'EXPIRED',
  SCHEDULED_TO_EXPIRE: 'SCHEDULED_TO_EXPIRE',
};

export {
  MIN_GALLERY_PRICE,
  MIN_PF_PPG_GALLERY_PRICE,
  MIN_PHOTO_BUNDLE_PRICE,
  MIN_SINGLE_PHOTO_BUNDLE_PRICE,
  ALBUM_FOLDER_JOIN_TYPE,
  ALBUM_FOLDER_MEMBERS_SORT,
  ALBUM_FOLDER_MEMBERS_SORT_LABELS,
  ALBUM_FOLDER_DIGITAL_DOWNLOADS_PRICING_TYPE,
  PHOTO_SHARING_MODE,
  PHOTO_SHARING_MODE_LABEL,
  PICTURE_DAY_FLOW_STEPS,
  ALL_PHOTOS_MODE,
  EVENT_SETTING_RELATIONSHIP,
  EVENT_SETTING_ANNIVERSARY,
  ALBUM_FOLDER_EXPIRATON_STATUS,
};
